import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import { GET_PLUG_DETAILS } from "../../api/gqlQueries";
import { IBrilliantPlug } from "../../interfaces/interfaces";
import Spinner from "../Spinner";
import { ReactComponent as Plug } from "../../img/Devices/Plug.svg";
import { getReadableTime } from "../../utils/utils";

export interface IPlugDetailsProps {
  deviceId: string;
  propertyId: string;
  setDeviceName: (name: string) => void;
}

const PlugDetails: React.FC<IPlugDetailsProps> = ({
  deviceId,
  propertyId,
  setDeviceName,
}: {
  deviceId: string;
  propertyId: string;
  setDeviceName: (name: string) => void;
}) => {
  const { data, loading } = useQuery<IBrilliantPlug>(GET_PLUG_DETAILS, {
    variables: { deviceId, propertyId },
  });
  useEffect(() => {
    setDeviceName(data?.brilliantPlug.name || "");
  }, [data]);
  if (loading) return <Spinner />;
  if (!data) return <div>No data was returned</div>;
  return (
    <>
      <div className="device-details-container">
        <div className="device-details-container-header">
          <div className="device-details-container-left">
            <Plug
              title="Smart Plug"
              className="brilliant-card-img-left brilliant-card-img-stroke"
            />
            <div>
              <div className="unit-title hidden-name">
                {data.brilliantPlug.name}
              </div>
              <div className="brilliant-card-description-type unit-description-small flex-display uppercase">
                Brilliant Plug
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="brilliant-container-name menu">Device Information</div>
      <div className="device-details-container device-details-container-info device-details-container-info-3">
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Device Name
          </div>
          <div className="tool-tip margin-bottom-small">
            {data.brilliantPlug.name}
          </div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Assigned To
          </div>
          <div className="tool-tip">{data.brilliantPlug.roomName}</div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Controls A Light?
          </div>
          <div className="tool-tip">
            {data.brilliantPlug.controlsLight ? "Yes" : "No"}
          </div>
        </div>
      </div>
      <br />
      <div className="brilliant-container-name menu">Connectivity</div>
      <div className="device-details-container device-details-container-info device-details-container-info-2">
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Last Software Update
          </div>
          <div className="tool-tip">
            {getReadableTime(data.brilliantPlug.lastSoftwareUpdate || "")}
          </div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Last Cloud Sync
          </div>
          <div className="tool-tip">
            {getReadableTime(data.brilliantPlug.lastKnownCloudSync || "")}
          </div>
        </div>
      </div>
    </>
  );
};
export default PlugDetails;
